var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file_2512918 1",
    clipPath: "url(#clip0_3301_7321)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.99951 9.00281H15.9941V10.6438H9.99951V9.00281Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.81287 11.3311L8.87995 9.64278L7.8419 8.37186L6.39718 9.55186L5.90913 8.97919L4.66016 10.0435L5.66939 11.2279C6.0899 11.6923 6.66067 11.4554 6.81287 11.3311Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.99951 4.89786H15.9941V6.53888H9.99951V4.89786Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.81287 7.22616L8.87995 5.5378L7.8419 4.26688L6.39718 5.44688L5.90913 4.87421L4.66016 5.93862L5.66939 7.12288C6.12836 7.60257 6.66062 7.35047 6.81287 7.22616Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M4.6748 13.122H15.9815V14.763H4.6748V13.122Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M19.0152 14.9474V1.84615C19.0152 0.828154 18.187 0 17.169 0H3.48727C2.46927 0 1.64111 0.828154 1.64111 1.84615V18.8393C1.64111 19.8573 2.46927 20.6855 3.48727 20.6855H13.3153C13.8783 22.599 15.6503 24 17.7437 24C20.2886 24 22.3591 21.9295 22.3591 19.3846C22.3591 17.2805 20.9437 15.5009 19.0152 14.9474ZM13.1409 19.0445H3.48727C3.37414 19.0445 3.28214 18.9525 3.28214 18.8393V1.84615C3.28214 1.73303 3.37414 1.64103 3.48727 1.64103H17.169C17.2821 1.64103 17.3741 1.73303 17.3741 1.84615V14.7841C15.1135 14.964 13.3066 16.7799 13.1409 19.0445ZM17.7437 22.359C16.1036 22.359 14.7693 21.0247 14.7693 19.3846C14.7693 17.7446 16.1036 16.4103 17.7437 16.4103C19.3837 16.4103 20.718 17.7446 20.718 19.3846C20.718 21.0247 19.3837 22.359 17.7437 22.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M17.7437 17.0769C17.3772 17.0769 17.0872 17.3864 17.1115 17.7513L17.2497 19.8257C17.267 20.0853 17.483 20.2871 17.7437 20.2871C18.0044 20.2871 18.2204 20.0853 18.2377 19.8257L18.3758 17.7513C18.4001 17.3864 18.1101 17.0769 17.7437 17.0769Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M17.7437 21.6923C18.0389 21.6923 18.2783 21.4534 18.2783 21.1587C18.2783 20.864 18.0389 20.625 17.7437 20.625C17.4485 20.625 17.2092 20.864 17.2092 21.1587C17.2092 21.4534 17.4485 21.6923 17.7437 21.6923Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3301_7321"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.60eb13ceb80f32f5439308b6ec95a756.svg";
export { ForwardRef as ReactComponent };